import React from "react";
import PropTypes from "prop-types";
import BondBillingInformationBase from "../../../../features/bonds/shared/components/BondBillingInformationBase";
import { getBillingSurfaceConfig } from "../../../../features/bonds/shared/billingSurfaceConfig";
import HistoricLabeledCreatableSelect from "../../../../features/bonds/shared/components/HistoricLabeledCreatableSelect";
import {
  GoogleAutoComplete,
  PLACES_TYPES_GEOCODE,
} from "../../../../globals/components/forms/GoogleAutoCompleteField";

const HistoricBillingGoogleAutoComplete = (props) => (
  <GoogleAutoComplete placesTypes={PLACES_TYPES_GEOCODE} {...props} />
);

export const BillingInformationForm = ({ data, updateData, globalData }) => (
  <BondBillingInformationBase
    cfg={getBillingSurfaceConfig("historic")}
    GoogleAutoComplete={HistoricBillingGoogleAutoComplete}
    LabeledCreatableSelect={HistoricLabeledCreatableSelect}
    data={data}
    updateData={updateData}
    globalData={globalData}
  />
);

BillingInformationForm.propTypes = {
  data: PropTypes.object.isRequired,
  updateData: PropTypes.func.isRequired,
  globalData: PropTypes.object.isRequired,
};
